// Twilio Function URL to Get Available Workers
var twilioFunctionUrl = "https://fyi-assets-gcx-9117.twil.io/task-queue-available-workers";

// Number of Available Agents to Display Webchat
var availableAgents = 1;

// Seconds to Display webchat (in miliseconds)
var webchatDisplayTime = 30000;


if ((window.location.href.includes('visique') && window.location.href.includes('en')) || (window.location.href.includes('fyi') && !window.location.href.includes('fr'))) {
  var taskQueueSid = "WQf4346967c241b5c23a7722d23cdd9e44";
  var flexFlowSid = "FO6bd0e4785a7de73dc703619367f5a9a4";
  var titleText = "Virtual Stylist";
  var tagline = "Speak with a Stylist";
  var yourDefaultName = "You";
  var theirDefaultName = "Stylist"
  var friendlyName = "Anonymous"
} else {
  var taskQueueSid = "WQ71ed7122667b38c52c5bc058a334181c"
  var flexFlowSid = "FOe964e813620de9ca040ac7fe83dda95e";
  var titleText = "Styliste virtuel";
  var tagline = "Parlez avec un styliste";
  var yourDefaultName = "Vous";
  var theirDefaultName = "Styliste"
  var friendlyName = "Anonyme"
}


var taskQueueSid = taskQueueSid;
var appConfig = {
  accountSid: "AC33df53018c139558d518d9c223340edb",
  flexFlowSid: flexFlowSid,
  startEngagementOnInit: true,
  preEngagementConfig: {},
  componentProps: {
    MainHeader: {
      showImage: false,
      titleText: titleText
    },
    EntryPoint: {
      tagline: tagline,
    },
    MessagingCanvas: {
      avatarCallback: identity => `https://fyi-flexfig-prod-8021.twil.io/webchat/chat-avatar?identity=${identity}`,
      memberDisplayOptions: {
        yourDefaultName: yourDefaultName,
        theirDefaultName: theirDefaultName,
        yourFriendlyNameOverride: false,
        theirFriendlyNameOverride: false
      }
    },
    MessageList: {},
    MessageListItem: {
      messageStyle: "Squared"
    }
  },
  context: {
    friendlyName: friendlyName
  },
  colorTheme: {
    overrides: {
      MainContainer: {
        borderRadius: '10px',
      },
      Chat: {
        MessageListItem: {
          FromMe: {
            Avatar: {
              height: '36px',
              width: '36px'
            }
          },
          FromOthers: {
            Avatar: {
              height: '36px',
              width: '36px'
            }
          }
        },
      },
      EntryPoint: {
        Container: {
          background: "#426cf4",
          "&:hover": {
            backgroundColor: "#8ea7f8",
          },
        },
      },
    },
  },
  fileAttachment: {
    enabled: true,
  },
};
